import { axios } from "@/utils/request";

// 获取子集
export function getChild(param) {
  return axios({
    url: "/api/Get/Dic",
    method: "post",
    data: param
  });
}

// 获取产品分类详情
export function getProductCategory(param) {
  return axios({
    url: "/api/Get/DicDt",
    method: "post",
    data: param
  });
}

// 获取轮播图
export function getSwiper(param) {
  return axios({
    url: "/api/Get/lunboPic",
    method: "post",
    data: param
  });
}

// 获取首页轮播
export function getIndexSwiper(param) {
  return axios({
    url: "/api/Get/IndexGoods",
    method: "post",
    data: param
  });
}

// 获取网页配置
export function getIndexBody(param) {
  return axios({
    url: "/api/Get/IndexBody",
    method: "post",
    data: param
  });
}

// 获取荣誉
export function getHonor(param) {
  return axios({
    url: "/api/Get/rongyuInfo",
    method: "post",
    data: param
  });
}

// 获取产品
export function getProduct(param) {
  return axios({
    url: "/api/Get/GoodsInfo",
    method: "post",
    data: param
  });
}

// 获取新闻
export function getNews(param) {
  return axios({
    url: "/api/Get/NewsInfo",
    method: "post",
    data: param
  });
}

// 获取新闻详情
export function getNewsDetails(param) {
  return axios({
    url: "/api/Get/NewsDt",
    method: "post",
    data: param
  });
}

// 获取历程
export function getCourse(param) {
  return axios({
    url: "/api/Get/Licheng",
    method: "post",
    data: param
  });
}
